import React from 'react';
import styled from "styled-components";
import ConvertPixelToRem from "@helpers/convert.rem";
import Icon from "@atoms/icon";
import CameraIcon from '@icons/camera.svg'
import VideoIcon from '@icons/video-camera.svg'

const MediaItems = ({img_count, video_count}) => {
    return (
        <React.Fragment>
            {
                (video_count > 0) ?
                    <Icon width="16" height="16" className={((img_count > 0) ? "ml-8" : ' just-video')}><VideoIcon/></Icon>
                    : ''
            }

            {
                (img_count > 0) ?
                    <Camera className="d-flex">
                        <span>{img_count}</span>
                        <Icon width="16" height="18"><CameraIcon/></Icon>
                    </Camera>
                    : ''
            }
        </React.Fragment>
    )
};

export default React.memo(MediaItems);

// styles

const Camera = styled.div`
    span {
        position: relative;
        top: 1px;
        margin-left: 4px;
        line-height: 1.58;
        font-size: ${ConvertPixelToRem(12)};
    }
`;
